export enum USER_GROUPS {
  READ_ONLY = 'READ_ONLY',
  SUPER_LOOKER = 'SUPER_LOOKER',
}
